module.exports = "/_next/static/images/doge-7514f40613f0421b479f0d8e915351a2.svg";